import { ResponsiveLayout, RuntimeComponentConfig } from 'config/wls/wlConfig';
import breakpoints from 'constants/breakpoints';
import React from 'react';

function isResponsiveLayout<T>(value: any): value is ResponsiveLayout<T> {
  return (
    value &&
    typeof value === 'object' &&
    ('desktop' in value || 'mobile' in value)
  );
}

const registry = new Map<string, RuntimeComponentConfig>();

export const ComponentRegistry = {
  register(name: string, config: RuntimeComponentConfig) {
    registry.set(name, config);
  },

  get(name: string): RuntimeComponentConfig | null {
    return registry.get(name) ?? null;
  },

  getComponent<T extends React.ComponentType<any> = React.ComponentType<any>>(
    name: string,
    defaultComponent?: T
  ): T {
    return registry.get(name)?.component ?? defaultComponent;
  },

  getConfig(name: string) {
    return registry.get(name) ?? null;
  },

  getProps(name: string) {
    return registry.get(name)?.props ?? null;
  },

  clear() {
    registry.clear();
  },

  getAll() {
    return Object.fromEntries(registry.entries());
  },

  getResolvedLayout<T>(name: string, fallback: T): T {
    const config = registry.get(name);
    if (!config?.layout) {
      return fallback;
    }

    const layout = config.layout;

    if (isResponsiveLayout<T>(layout)) {
      const isMobile = window.innerWidth <= breakpoints.header;

      const resolved = isMobile
        ? (layout.mobile ?? layout.desktop)
        : (layout.desktop ?? layout.mobile);

      return (resolved ?? fallback) as T;
    }

    return (layout as T) ?? fallback;
  },
};
